import type { CreatePropertyMutationRequest, CreatePropertyMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'

export function createPropertyHandler() {
  return http.post<
    never,
    CreatePropertyMutationRequest,
    CreatePropertyMutationResponse
  > ('http://localhost:3000/api/v1/property', () => {
    return HttpResponse.json({
      id: '1',
    })
  })
}
